<template>
  <div id="wrap">
    <!-- logo -->
    <div class="logo"></div>
    <!-- title -->
    <div class="title">安全回收</div>
    <div class="text">同城帮获有安全技术，通过人工智能、大数据与底层硬件技术革新迭代，赋能上万二手行业从业组织提供隐私保障服务，推动二手数码行业的数据安全跨入新的里程碑。</div>
    <!-- 第一个展示栏 -->
    <div class="displayBar1">
      <div class="img"></div>
      <div class="content">
        <div class="title">专业手机安全回收</div>
        <div
          class="text"
        >同城帮拥有自主研发的隐私粉碎技术，通过硬件底层技术，可粉碎电子产品数据的同时不损坏硬件，结合大数据能力为普通手机回收用户提供隐私粉碎报告，突破手机回收行业数据安全性难题，消解用户回收顾虑。</div>
      </div>
    </div>
    <!-- 第二个展示栏 -->
    <div class="displayBar2">
      <div class="content">
        <div class="title">隐私粉碎</div>
        <div class="text">同城帮隐私安全处理团队，具有多年底层安全技术沉淀，有很强的数据安全技术处理能力和隐私粉碎能力。</div>
      </div>
      <div class="img"></div>
    </div>
    <!-- 第三个展示栏 -->
    <div class="displayBar3">
      <div class="img"></div>
      <div class="content">
        <div class="title">人工智能检测</div>
        <div
          class="text"
        >同城帮具有多年人工智能技术沉淀，通过自动化人工智能技术能力赋能，提升手机质检、隐私粉碎、拣货发货、库存仓储、自动话流转等后端运营效率，降低行业运营成本。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  //   background-color: skyblue;
  .logo {
    width: 70px;
    height: 70px;
    background-image: url("../../assets/imgs/product/logoicon.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 30px;
  }
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 60px;
  }
  //   展示区
  .displayBar1 {
    width: 1034px;
    height: 321px;

    display: flex;
    margin-bottom: 60px;
    box-shadow: 0px 0px 20px #eee;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p3.ssl.qhimg.com/t01b1c09fb0ee29dca4.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   第二个展示区
  .displayBar2 {
    width: 1034px;
    height: 321px;
    box-shadow: 0px 0px 20px #eee;
    display: flex;
    margin-bottom: 60px;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p2.ssl.qhimg.com/t010c5119917be33c61.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 78px 53px 110px 64px;
      text-align: right;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   展示区
  .displayBar3 {
    width: 1034px;
    height: 321px;
    box-shadow: 0px 0px 20px #eee;
    display: flex;
    margin-bottom: 60px;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p1.ssl.qhimg.com/t0157e1afc868541c05.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
</style>
